<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 验证码 -->
      <section slot="messageCode" slot-scope="prop">
        <el-input
          class="inputBox"
          :disabled="isAddNewAccountBankRel"
          v-model="prop.form.messageCode"
        >
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >
            {{ smsTime || '获取短信验证码' }}
          </article>
        </el-input>
        <span class="primary changeBtn cur" @click="changeCheck('tranAmount')"
          >切换小额授权</span
        >
      </section>
      <!-- 验证码 end -->
      <!-- 小额鉴权 -->
      <section slot="tranAmount" slot-scope="prop">
        <el-input
          class="inputBox"
          :disabled="isAddNewAccountBankRel"
          v-model="prop.form.tranAmount"
        >
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >
            {{ smsTime || '获取鉴权' }}
          </article>
        </el-input>
        <span
          v-show="$route.query.type === 'private'"
          class="primary changeBtn cur"
          @click="changeCheck('messageCode')"
          >切换短信验证</span
        >
      </section>
      <!-- 小额鉴权 end -->
      <section slot="logonAndBindcard" slot-scope="prop">
        <el-radio
          v-model="prop.form.logonAndBindcard"
          :label="true"
          @click.prevent.native="checkRadio(true)"
          >新增账户并绑卡</el-radio
        >
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  // bindBankcardGetSms,
  getEnumList,
  getBankInfoList,
  getBankTieInfo,
} from 'api';
import {
  getAddressOptions,
  findAddressName,
} from '@qx/utils';
import {
  servicerBindBankcard,
} from 'api/service';
import {
  mapState,
} from 'vuex';
import {
  companyBankcardList,
} from 'api/getPay';
export default {
  data () {
    return {
      isLoadCache: false,
      isAddNewAccountBankRel: true,
      smsTimer: null,
      smsTime: 0,
      checkType: 'messageCode',
      otherFormData: {
        branchInfo: {},
      },
      baseForm: {
        bankIdOptions: [], // 开户银行
        branchIdOptions: [], // 支行
        form: [
          {
            label: '私人账户持卡人',
            value: 'custName',
            type: 'input',
            readonly: false,
          },
          {
            label: '信用代码',
            value: 'businessLicenseNo',
            type: 'input',
            readonly: false,
          },
          {
            label: '身份证号',
            value: 'identification',
            type: 'input',
            readonly: false,
          },
          {
            label: '银行卡号',
            value: 'acctId',
            type: 'input',
            readonly: false,
          },
          {
            label: '开户银行',
            value: 'bankId',
            type: 'select',
            filterable: true,
            readonly: false,
            onChange: () => {
              this.handleBankBranchChange();
            },
          },
          {
            label: '开户省市',
            value: 'address',
            type: 'cascader',
            placeholder: ' ',
            fakeShow: true,
            default: [],
            // options: getAddressOptions({ type: 'pingan' }),
            options: getAddressOptions(),
            onChange: () => {
              this.handleBankBranchChange();
            },
          },
          // {
          //   label: '开户支行',
          //   value: 'branchInfo',
          //   type: 'el-autocomplete',
          //   valueKey: 'label',
          //   disabled: false,
          //   querySearchAsync: (keyWord, cb) => {
          //     let res = [];
          //     if (keyWord && keyWord.length) {
          //       const bankId = this.$refs.baseForm.getVal('bankId');
          //       const address = this.$refs.baseForm.getVal('address');
          //       if (bankId && address.length) {
          //         getBankInfoList({
          //           bankId,
          //           cityCode: address[1],
          //           keyWord,
          //         }).then((res) => {
          //           if (res && res.items) {
          //             res = res.items;
          //           }
          //           cb(res);
          //         });
          //       }
          //     }
          //     cb(res);
          //   },
          //   onSelect: (item) => {
          //     this.otherFormData.branchInfo = item;
          //   },
          // },
          {
            label: '开户支行',
            value: 'branchInfo',
            type: 'input',
            readonly: false,
          },
          {
            label: '手机号',
            value: 'mobilePhone',
            type: 'input',
            disabled: false,
            hide: false,
          },
          // {
          //   label: '验证码',
          //   value: 'messageCode',
          //   slot: true,
          //   hide: false,
          // },
          // {
          //   label: '小额鉴权',
          //   value: 'tranAmount',
          //   slot: true,
          //   hide: true,
          // },
          // {
          //   label: '新增类型',
          //   value: 'logonAndBindcard',
          //   hide: false,
          //   slot: true,
          // },
          {
            label: '默认账户',
            value: 'isDefaultAcct',
            type: 'radio',
            default: true,
            hide: false,
            options: [
              {
                label: '是',
                value: true,
              },
              {
                label: '否',
                value: false,
              },
            ],
          },
        ],
        rules: {
          custName: [ // 账户名
            { required: true, message: '账户名', trigger: 'blur' },
          ],
          businessLicenseNo: [ // 信用代码
            { required: true, message: '请输入信用代码', trigger: 'blur' },
          ],
          identification: [ // 身份证号
            { required: true, message: '请输入身份证号', trigger: 'blur' },
          ],
          acctId: [ // 银行卡号
            { required: true, message: '请输入银行卡号', trigger: 'blur' },
          ],
          bankId: [ // 开户银行
            { required: true, message: '请选择开户银行', trigger: 'blur' },
          ],
          address: [ // 开户省市
            { required: true, message: '请选择开户省市', trigger: 'blur' },
          ],
          mobilePhone: [ // 手机号
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          messageCode: [ // 验证码
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
          tranAmount: [ // 小额鉴权
            { required: true, message: '请输入小额鉴权金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    checkRadio (val) {
      const logonAndBindcard = this.$refs.baseForm.getVal('logonAndBindcard');
      let currentValue = false;
      if (val === logonAndBindcard) {
        this.$refs.baseForm.setVal('logonAndBindcard', false);
      } else {
        this.$refs.baseForm.setVal('logonAndBindcard', val);
        currentValue = val;
      }
      // 控制 手机号码 和 验证码，如果不选中 新增并绑卡，就不需要填写 手机号码 和 验证码
      this.isAddNewAccountBankRel = !currentValue;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !currentValue,
        names: ['mobilePhone'],
      });
      this.$set(this.baseForm.rules[this.checkType][0], 'required', currentValue);
      this.$set(this.baseForm.rules.mobilePhone[0], 'required', currentValue);
    },
    handleAccountTypeShow () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: false,
        names: ['custName', 'businessLicenseNo', 'identification', 'acctId', 'bankId', 'mobilePhone'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['mobilePhone', 'messageCode', 'tranAmount', 'isDefaultAcct', 'logonAndBindcard'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'readonly',
        value: false,
        names: ['identification'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: this.$route.query.type === 'public',
        names: ['identification'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: this.$route.query.type === 'private',
        names: ['businessLicenseNo'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'label',
        value: this.$route.query.type === 'public' ? '对公账户名' : '私人账户持卡人',
        names: ['custName'],
      });
      if (this.$route.query.type === 'private') {
        this.changeCheck('messageCode');
      } else {
        this.changeCheck('tranAmount');
      }
    },
    handleBankBranchChange () { // 银行支行显示控制
      const bankId = this.$refs.baseForm.getVal('bankId');
      const address = this.$refs.baseForm.getVal('address');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !(bankId && address.length !== 0),
        names: ['branchInfo'],
      });
    },
    async getBranchId (keyWord) { // 获取支行选择列表
      if (!keyWord) {
        this.baseForm.branchIdOptions = [];
        return;
      }
      const bankId = this.$refs.baseForm.getVal('bankId');
      const address = this.$refs.baseForm.getVal('address');
      this.baseForm.branchIdOptions = await getBankInfoList({
        bankId,
        cityCode: address[1],
        keyWord,
      });
    },

    // 控制修改模式下显示隐藏
    ctrlModeShowHide () {
      if (this.$route.query.id) {
        if (this.$route.query.ctrlType === 'bindcard') {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'readonly',
            value: true,
            names: ['identification'],
          });
        }
        if (this.$route.query.ctrlType === 'edit') {
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: true,
            names: ['mobilePhone', 'messageCode', 'tranAmount', 'isDefaultAcct'],
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: true,
            names: ['custName', 'businessLicenseNo', 'identification', 'acctId', 'bankId'],
          });
        }
      }
    },

    changeCheck (tar) { // 验证方式选择
      this.checkType = tar;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: tar !== 'messageCode',
        names: ['messageCode'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: tar !== 'tranAmount',
        names: ['tranAmount'],
      });
      const required = this.$refs.baseForm.getVal('logonAndBindcard');
      this.$set(this.baseForm.rules[this.checkType][0], 'required', required);
    },
    async getSms () { // 获取短信验证码
      this.$message.error('此功能暂时未开发！');
      // if (this.isAddNewAccountBankRel) {
      //   return;
      // }
      // if (this.smsTime > 0) {
      //   return;
      // }
      // this.smsTime = 20;
      // const formData = await this.handleSubData(true);
      // let params = JSON.parse(JSON.stringify(formData));
      // if (this.$route.query.id && this.$route.query.ctrlType === 'bindcard') {
      //   // 重新绑卡
      //   params.relSeq = this.$route.query.id;
      //   params.userType = 1;
      //   params.busiId = this.$route.query.userId;
      //   params.logCode = 100005;
      // }
      // if (params.bankType === 1) {
      //   // 对公
      // } else {
      //   // 对私
      //   if (this.checkType === 'messageCode') {
      //     // 验证码
      //     params.tranAmountFlag = null;
      //   } else {
      //     // 鉴权
      //     params.tranAmountFlag = 1;
      //   }
      // }
      // delete params.billPlatFormToBindCard;
      // delete params.bindType;
      // delete params.tranAmountFlag;
      // delete params.branchInfo;
      // const res = await bindBankcardGetSms(params);
      // if (!res.failed) {
      //   let msg = '';
      //   let msgType = 'success';
      //   if (params.bankType === 1) {
      //     // 对公
      //     if (res.info === 'Y') {
      //       msg = '请查看银行流水，并将最近一笔由平安银行汇入小于1元的转账金额填在小额鉴权中！';
      //       msgType = 'success';
      //     } else if (res.info === 'N') {
      //       msg = '获取小额鉴权失败，失败原因：' + res.errMesg + '，请检查填入的信息';
      //       msgType = 'warning';
      //     }
      //   } else {
      //     // 对私
      //     if (res.info === 'Y') {
      //       msgType = 'success';
      //       if (this.checkType === 'messageCode') {
      //         msg = '验证码已发送，请可留意查收';
      //       } else {
      //         msg = '请查看银行流水，并将最近一笔由平安银行汇入小于1元的转账金额填在小额鉴权中！';
      //       }
      //     } else {
      //       msgType = 'warning';
      //       if (this.checkType === 'messageCode') {
      //         msg = '获取验证码失败，失败原因：' + res.errMesg;
      //       } else {
      //         msg = '获取小额鉴权失败，失败原因：' + res.errMesg;
      //       }
      //     }
      //   }
      //   this.$message[msgType](msg);
      //   if (msgType === 'warning') {
      //     this.smsTime = 0;
      //     return;
      //   }
      //   clearInterval(this.smsTimer);
      //   this.smsTimer = setInterval(() => {
      //     this.smsTime--;
      //     if (this.smsTime <= 0) {
      //       this.smsTime = 0;
      //       clearInterval(this.smsTimer);
      //     }
      //   }, 1000);
      // } else if (!res.failed) {
      //   this.$message.error(res.errMesg);
      //   this.smsTime = 0;
      // } else {
      //   this.smsTime = 0;
      // }
    },

    async getList () {
      const enumsList = await getEnumList({
        codeType: 'BANK_TYPE',
      });
      this.baseForm.bankIdOptions = enumsList[0];
    },

    // 自动填写银行信息
    async getBankTieInfo () {
      if (this.$route.query.id && (this.$route.query.ctrlType === 'bindcard')) {
        // 如果是重新绑卡，需要回显之前填写的信息
        const bankType = this.$route.query.type === 'private' ? 0 : 1;
        const data = await getBankTieInfo({
          userId: this.$route.query.userId,
          bankType,
          relSeq: this.$route.query.id,
        });
        if (!data.failed) {
          if (data.bankTailNumber) {
            const confirmRes = await this.$confirm('尾号' + data.bankTailNumber + '的银行卡' + data.saveTime + '已成功获取小额鉴权，请直接输入金额!', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).catch(() => {
              // 取消
            });
            if (confirmRes === 'confirm') {
              if (bankType === 1) {
                this.$refs.baseForm.setVal('custName', data.custName);
                this.$refs.baseForm.setVal('businessLicenseNo', data.businessLicenseNo);
                this.$refs.baseForm.setVal('identification', data.identification);
                this.$refs.baseForm.setVal('acctId', data.acctId);
                this.$refs.baseForm.setVal('branchName', data.branchName);
                this.$refs.baseForm.setVal('mobilePhone', data.mobilePhone);
                this.$refs.baseForm.setVal('bankId', data.bankId);
                // this.$refs.baseForm.setVal('branchInfo', data.branchName);
                this.$refs.baseForm.setVal('address', [data.provinceId, data.cityId]);
                this.handleBankBranchChange();
              }
            }
          }
        }
      }
    },

    async setDefaultDataInInit (data) {
      if (!this.$route.query.id) {
        // 如果 url 上没有 id，表示新增状态
        if (!data.custName || !data.businessLicenseNo) {
          const identification = this.$route.query.identification;
          let acctName = this.$route.query.acctName;
          if (identification && acctName) {
            // 如果有账号信息和联系人信息，去查这个账号的身份证信息
            acctName = decodeURIComponent(acctName);
            this.$refs.baseForm.setVal('custName', acctName);
            this.$refs.baseForm.setVal('identification', identification);
            this.$refs.baseForm.setVal('businessLicenseNo', identification);
          } else {
            // 而且 custName 和 businessLicenseNo 之前没有缓存值，默认读取接口信息
            const res = await companyBankcardList({
              userId: this.userInfo.staffTFInfo.userId,
              userType: 2,
              showMoney: 'true',
            });
            if (!res.failed) {
              this.$refs.baseForm.setVal('custName', res.companyName);
              this.$refs.baseForm.setVal('businessLicenseNo', res.businessLicenseNo);
            }
          }
        }
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['logonAndBindcard'],
        });
        if (this.$route.query.ctrlType === 'edit') {
          await this.setDataForEdit(data);
        } else {
          if (!data.custName || !data.businessLicenseNo) {
            // 重新绑卡的情况下，从 url 带入之前填写好的绑卡信息
            if (this.$route.query.acctName) {
              const custName = decodeURIComponent(this.$route.query.acctName);
              this.$refs.baseForm.setVal('custName', custName);
            }
            if (this.$route.query.businessLicenseNo) {
              const businessLicenseNo = this.$route.query.businessLicenseNo;
              this.$refs.baseForm.setVal('businessLicenseNo', businessLicenseNo);
            }
            if (this.$route.query.identification) {
              const identification = this.$route.query.identification;
              this.$refs.baseForm.setVal('identification', identification);
            }
          }
        }
      }
    },
    // 设置修改状态的值
    async setDataForEdit (data) {
      let cardInfo = null;
      const res = await servicerBindBankcard({
        userId: this.$route.query.userId,
        userType: 2,
      });
      let listTypeName = '';
      if (this.$route.query.type === 'public') {
        listTypeName = 'allPubAcct';
      }
      if (this.$route.query.type === 'private') {
        listTypeName = 'allPriAcct';
      }
      if (res[listTypeName] && res[listTypeName].length) {
        for (let item of res[listTypeName]) {
          if (item.relSeq === Number(this.$route.query.id)) {
            cardInfo = item;
          }
        }
      }
      if (cardInfo) {
        if (!data.custName) {
          this.$refs.baseForm.setVal('custName', cardInfo.acctName);
        }
        if (!data.bankId) {
          this.$refs.baseForm.setVal('bankId', cardInfo.bankId);
        }
        if (!data.identification) {
          this.$refs.baseForm.setVal('identification', cardInfo.identification);
        }
        if (!data.businessLicenseNo) {
          this.$refs.baseForm.setVal('businessLicenseNo', cardInfo.businessLicenseNo);
        }
        if (!data.acctId) {
          this.$refs.baseForm.setVal('acctId', cardInfo.acctNo);
        }
        if (!data.address || !(data && data.address && data.address.length)) {
          this.$refs.baseForm.setVal('address', [cardInfo.provinceId, cardInfo.cityId]);
          const addressName = cardInfo.provinceName + ((cardInfo.provinceName && cardInfo.cityName) ? '/' : '') + cardInfo.cityName;
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'placeholder',
            value: addressName || ' ',
            names: ['address'],
          });
        }

        if (!(data.branchName && data.branchId)) {
          if (cardInfo.branchName && cardInfo.branchId) {
            // 读取接口信息
            this.otherFormData.branchInfo = {
              label: cardInfo.branchName,
              value: cardInfo.branchId,
            };
            this.$refs.baseForm.setVal('branchInfo', cardInfo.branchName);
          }
        }

        this.isLoadCache = true;
      }
    },

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        let provinceName = '';
        let cityName = '';
        // let branchName = '';
        if (formData.address && formData.address.length === 2) {
          const addressNames = await findAddressName({
            arr: formData.address,
            // type: 'pingan',
          });
          provinceName = addressNames[0];
          cityName = addressNames[1];
        }
        // // 支行名称
        // if (formData.branchId) {
        //   for (let i = 0; i < this.baseForm.branchIdOptions.length; i++) {
        //     if (this.baseForm.branchIdOptions[i].value === String(formData.branchId)) {
        //       branchName = this.baseForm.branchIdOptions[i].label;
        //       break;
        //     }
        //   }
        // }
        formData = {
          logonAndBindcard: formData.logonAndBindcard,
          provinceName,
          cityName,
          branchName: formData.branchInfo,
          // branchName: this.otherFormData.branchInfo.label,
          custName: formData.custName, // 私人账户持卡人
          businessLicenseNo: formData.businessLicenseNo, // 信用代码
          newMod: true,
          isDefaultAcct: formData.isDefaultAcct,
          identification: formData.identification, // 身份证号
          bankId: formData.bankId, // 开户银行
          acctId: formData.acctId, // 银行卡号
          provinceId: formData.address[0], // 省
          cityId: formData.address[1], // 市
          // branchId: this.otherFormData.branchInfo.value, // 开户支行
          mobilePhone: formData.mobilePhone, // 手机号
          messageCode: formData.messageCode, // 验证码
          tranAmount: formData.tranAmount, // 小额鉴权
          bindType: this.checkType === 'messageCode' ? 0 : 1,
          bankType: this.$route.query.type === 'private' ? 0 : 1,
          userId: this.$route.query.userId,
          userType: Number(this.$route.query.userType) || 6,
          logCode: 400000,
          busiId: 1315,
        };
        // 不知道为什么之前的这个参数永远是错的，这里修正过来
        formData.relSeq = this.$route.query.id;
        if (this.$route.query.type === 'private') {
          // 对私才有这个参数
          formData.tranAmountFlag = this.checkType === 'messageCode' ? 0 : 1;
        } else {
          // 对公
        }
        if (this.$route.query.id) {
          if (this.$route.query.ctrlType === 'bindcard' || this.$route.query.ctrlType === 'edit') {
            // 重新绑卡/修改
            formData.ctrlType = this.$route.query.ctrlType;
            formData.userType = Number(this.$route.query.userType); // 员工管理过来的绑卡userType传2
            formData.busiId = this.$route.query.userId;
            formData.logCode = 100005;
            formData.billPlatFormToBindCard = false;
          }
        } else {
          formData.isAddNewAccountBankRel = !this.isAddNewAccountBankRel;
        }
        // formData.branchInfo = this.otherFormData.branchInfo;
        formData.isLoadCache = this.isLoadCache;
      }
      // console.log('foratat', formData);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.branchInfo;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      res.bankIdOptions = this.baseForm.bankIdOptions;
      res.branchIdOptions = this.baseForm.branchIdOptions;
      return res;
    },
    async init (data = {}) {
      if (!data.isDefaultAcct) {
        data.isDefaultAcct = true;
      }
      if (data.logonAndBindcard === undefined) {
        data.logonAndBindcard = true;
      }
      this.isAddNewAccountBankRel = !data.logonAndBindcard;
      this.$set(this.baseForm.rules.mobilePhone[0], 'required', data.logonAndBindcard);

      if (data.provinceId) {
        data.address = [data.provinceId, data.cityId];
      } else {
        data.address = [];
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'placeholder',
          value: ' ',
          names: ['address'],
        });
      }

      this.otherFormData.branchInfo = {
        label: data.branchName || '',
        value: data.branchId || '',
      };

      data.branchInfo = data.branchName || '';
      this.baseForm.branchIdOptions = data.branchIdOptions || [];
      this.$refs.baseForm.setVal(data);
      this.handleAccountTypeShow();
      this.ctrlModeShowHide();
      await this.setDefaultDataInInit(data);
      this.handleBankBranchChange();
      // this.getBankTieInfo();
    },
  },
};
</script>

<style scoped lang="scss">
.getCodeBtn {
  padding-right: 8px;
}
.changeBtn {
  margin-left: 8px;
}
// ::v-deep .address-placeholder {
//   input::-webkit-input-placeholder {
//     color: #606266;
//   }
//   input:-moz-placeholder {
//     color: #606266;
//   }
// }
::v-deep
  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}
</style>
